export const textareaTextDict = {
    0: "每隔$日",
    1: "每周$",
    2: "每隔$周的周$",
    3: "每月$日",
    4: "每隔$个月$日",
    5: "每季度第$个月$日",
    6: "每年$月$日",
    7: "每隔$年的$月$日",
    8: "每月最后一个工作日",
    9: "每隔$月的最后一个工作日",
    10: "每季度的第$个月最后一个工作日",
    11: "每年$月最后一个工作日",
    12: "每月第$个周五（提前）",
    13: "每季度末最后一个周五",
    14: "每季度末最后一个周五（提前）",
    15: "每月最后一个周五",
    16: "每月最后一个周五（提前）",
    17: "每周最后一个工作日",
    18: "每周最后一个工作日（提前）",
    19: "每月第$个工作日",
    20: "每月第$个交易日",
    21: "每月$日后第$个工作日",
    22: "每月$日后第$个交易日",
    23: "每月第$个工作日后第$个工作日",
    24: "每月第$个交易日后第$个交易日",
    25: "每月最后一个工作日后第$个工作日",
    26: "每月最后一个工作日后第$个交易日",
    27: "每自然季度第$个月$日后$个工作日内",
    28: "每自然季度第$个月$日后$个交易日内",
    29: "每自然季度第$个月最后一个工作日后$个工作日内",
    30: "每自然季度第$个月最后一个交易日后$个交易日内",
    31: "每自然季度第$个月第$个工作日",
    32: "每自然季度第$个月第$个交易日",
    33: "对应季度第$个月$日后$个工作日内",
    34: "对应季度第$个月$日后$个交易日内",
    35: "对应季度第$个月最后一个工作日后$个工作日内",
    36: "对应季度第$个月最后一个交易日后$个交易日内",
    37: "对应季度第$个月第$个工作日",
    38: "对应季度第$个月第$个交易日",
    39: "对应季度第$个月最后一个工作日",
    40: "对应季度第$个月最后一个交易日",
    41: "对应季度第$个月$日",
    42: "季度对应日",
    43: "月度对应日",
    44: "每隔$日（交易日）",
    45: "每隔$周的周$（交易日）",
    46: "每隔$个月$日（交易日）",
    47: "每隔$年的$月$日（交易日）",
    48: "每隔$月的最后一个交易日",
    49: "每周$（交易日）",
    50: "每月$日（交易日）",
    51: "每自然季度第$个月最后一个工作日",
    52: "每自然季度第$个月最后一个交易日",
    53: "每自然季度第$个月$日",
    54: "每自然季度第$个月$日（交易日）",
    55: "对应季度第$个月$日（交易日）",
    56: "季度对应日（交易日）",
    57: "月度对应日（交易日）",
    58: "每年$月$日（交易日）",
    59: "每季度末最后一个周五（交易日）",
    60: "每月最后一个周五（交易日）",
    61: "每周最后一个交易日",
    62: "每季度第$个月$日（交易日）",
    63: "每月最后一个交易日",
    64: "每季度的第$个月最后一个交易日",
    65: "每年$月最后一个交易日",
    66: "无开放日",
    67: "无固定开放日"
}


// WEBPACK FOOTER //
// app/components/form/setting-textarea-control/options.js